import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/orders/create-manual-user-orders/global'

export const CREATE_MANUAL_USER_ORDERS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
